import { LicenseManager } from '@ag-grid-enterprise/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import localeIt from '@angular/common/locales/it';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { ApiClientModule } from '@ellf/app-api-client';
import { AppAuthModule } from '@ellf/app-auth';
import { AppFormsModule } from '@ellf/app-forms';
import { AppNgrxLoaderModule } from '@ellf/app-ngrx-loader';
import { RoutingModule } from '@ellf/app-routing';
import { UiKitModule } from '@ellf/app-ui-kit';
import { ErrorsModule } from '@ellf/error';
import {
  NgbCollapseModule,
  NgbDropdownModule,
} from '@ng-bootstrap/ng-bootstrap';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import * as moment from 'moment';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NgxPermissionsModule } from 'ngx-permissions';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './components/footer/footer.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { LayoutComponent } from './containers/layout/layout.component';
import { NotFoundPageContainer } from './not-found/not-found-page.container';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

// eslint-disable-next-line @typescript-eslint/no-var-requires, @nx/enforce-module-boundaries
const version = require('../../../../package.json').version;
@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    NavbarComponent,
    FooterComponent,
    NotFoundPageContainer,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    //routes
    AppRoutingModule,
    //ngrx store
    StoreModule.forRoot(
      {},
      {
        // metaReducers,
        runtimeChecks: {
          strictActionImmutability: true,
          strictStateImmutability: true,
        },
      },
    ),
    !environment.production
      ? StoreDevtoolsModule.instrument({ connectInZone: true })
      : [],
    NgxPermissionsModule.forRoot(),
    EffectsModule.forRoot([]),
    ApiClientModule.forRoot({
      apiEndpoint: environment.apiBaseUrl,
    }),
    RoutingModule,
    // from theme
    CommonModule,
    AppFormsModule,
    NgbDropdownModule,
    NgbCollapseModule,
    UiKitModule,
    // PerfectScrollbarModule,
    AppAuthModule.forRoot({
      tenantId: environment.aadTenantId,
      clientId: environment.aadClientId,
      apiEndpoint: environment.apiBaseUrl,
    }),
    ErrorsModule.forRoot({
      apiEndpoint: environment.apiBaseUrl,
    }),
    AppNgrxLoaderModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [
    // {
    //   provide: PERFECT_SCROLLBAR_CONFIG,
    //   useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    // },
    { provide: LOCALE_ID, useValue: 'it' },
    {
      provide: 'version',
      useValue: version,
    },
    {
      provide: 'env',
      useValue: environment.environment,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {
  constructor() {
    registerLocaleData(localeIt);
    moment.locale('it');

    LicenseManager.setLicenseKey(environment.agGridLicenseKey);
  }
}
